"use strict";
import {
  doConfigHooks,
  doConfigUnlockLevelRequirementHooks,
  doUTILSHooks,
} from "./hooks";
import notify from "./notify";

Object.defineProperty(Object.prototype, "assetsUrl", {
  set(assetsUrl) {
    if (!assetsUrl) return;
    delete Object.prototype.assetsUrl;
    this.assetsUrl = assetsUrl;
    doUTILSHooks(this);
  },
  configurable: true,
});

Object.defineProperty(Object.prototype, "regionNames", {
  set(value) {
    delete Object.prototype.regionNames;
    this.regionNames = value;
    doConfigHooks(this);
    // TODO: set to false when we develop the out of process matchmaker
    const isLocal = true; // location.hostname === "127.0.0.1";
    const state = window.__krunkerConnectState;
    if (state?.matchmakerURL && state.socialURL && state.apiURL) {
      this.socialURL = state.socialURL;
      this.apiURL = state.apiURL;
      this.editorURL = state.editorURL || location.origin + "/editor";
      this.matchmakerURL = state.matchmakerURL;
    } else {
      this.socialURL = isLocal
        ? location.origin + "/api"
        : "https://social.krunker.zip";
      this.apiURL = isLocal
        ? location.origin + "/api"
        : "https://api.krunker.zip";
      this.editorURL = isLocal
        ? location.origin + "/editor"
        : "https://editor.krunker.zip";
      this.matchmakerURL = isLocal
        ? location.origin + "/mm"
        : "https://matchmaker.krunker.zip";
    }
  },
  configurable: true,
});

Object.defineProperty(Object.prototype, "skinColors", {
  set(value) {
    delete Object.prototype.skinColors;
    this.skinColors = value;
    doConfigUnlockLevelRequirementHooks(this);
  },
  configurable: true,
});

const eventsMap = new WeakMap();

function sanitizeSandboxRawMapData(rawMapData) {
  try {
    const mapData = JSON.parse(rawMapData);
    const scripts = mapData.scripts;
    if (!scripts || typeof scripts !== "object") return rawMapData;
    for (const key of Object.keys(scripts)) {
      const value = scripts[key];
      if (typeof value !== "string") continue;
      if (looksLikeKrunkScript(value)) {
        delete scripts[key];
        continue;
      }
      if (looksLikeBase64Script(value)) {
        try {
          const decoded = atob(value);
          if (looksLikeKrunkScript(decoded)) delete scripts[key];
        } catch {}
      }
    }
    if (!Object.keys(scripts).length) delete mapData.scripts;
    return JSON.stringify(mapData);
  } catch {
    return rawMapData;
  }
}

function sanitizeSandboxInitCustomMapData(customMapData) {
  if (!customMapData || typeof customMapData !== "object") return;
  if (typeof customMapData.data !== "string") return;
  customMapData.data = sanitizeSandboxRawMapData(customMapData.data);
}

function looksLikeBase64Script(value) {
  return value.length > 16 && value.length % 4 === 0 && /^[A-Za-z0-9+/]+={0,2}$/.test(value);
}

function looksLikeKrunkScript(value) {
  return /(^|\n)\s*(#|public\s+action|action\s+|obj\s+|num\s+|str\s+|bool\s+)/.test(value);
}

function injectInitHook(events) {
  if (!events || typeof events.init !== "function" || events.init.__sanitizeSandboxMapScripts) return;
  const originalInit = events.init;
  const sanitizedInit = function (...args) {
    if (window.Game?.isSandbox) sanitizeSandboxInitCustomMapData(args[9]);
    return originalInit.apply(this, args);
  };
  sanitizedInit.__sanitizeSandboxMapScripts = true;
  events.init = sanitizedInit;
}

Object.defineProperty(Object.prototype, "events", {
  get() {
    if (typeof this.connect === "function") window.io = this;
    return eventsMap.get(this);
  },
  set(value) {
    if (value && typeof value === "object") {
      value.notify = notify;
      injectInitHook(value);
    }
    eventsMap.set(this, value);
  },
});

Object.defineProperty(Object.prototype, "shiftBannerFocus", {
  set: () => {
    throw "annoying";
  },
});

// PRESERVE EDITOR VAR

let KE;

Object.defineProperty(window, "KE", {
  get: () => {
    return KE;
  },
  set: (value) => {
    if (KE) {
      console.trace("WHAT");
      return;
    }
    KE = value;
  },
});
